export const courseDescriptionMaxLength = 65000;
export const defaultEditorHeadingLevel = 3;
export const teacherAvatarSize = 200;
export const teacherSectionId = 'teachers';

export const courseType = Object.freeze({
    Subject: 1,
    Class: 2,
    SelfPaced: 3,
    InformationHub: 4
});
